import constate from 'constate';
import { useMemo, useState } from 'react';
import { useVizFrameworkConfig } from '@/plugin-system/model';

export interface QueryLimits {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
  seriesLimit?: number;
}

function useQueryTruncationInternal() {
  const config = useVizFrameworkConfig();
  // TODO: add state for client-side partial rendering
  const [queryLimitsEnabled, setQueryLimitsEnabled] = useState(config?.enableQueryTruncation ?? true);

  const queryLimits: QueryLimits = useMemo(
    () => ({
      enabled: queryLimitsEnabled,
      setEnabled: (enabled) => {
        setQueryLimitsEnabled(enabled);
      },
      seriesLimit: config?.seriesLimit,
    }),
    [queryLimitsEnabled, config?.seriesLimit]
  );

  return {
    queryLimits,
  };
}

export const [QueryTruncationProvider, useQueryTruncationStrict] = constate(useQueryTruncationInternal);

export function useQueryTruncation() {
  try {
    return useQueryTruncationStrict();
  } catch (_e) {
    return undefined;
  }
}
